<template>
    <div class="card bg-dark text-white" @click="goTo(link)">
        <div class="imageContainer">
        <!-- <progressive-img :src="image" class="card-img" alt="..."/> -->
        <img :src="image" class="card-img" alt="..."/>
        </div>
        <!-- <div class="card-img-overlay">
            <div class="row h-100 justify-content-center align-items-center">
                <div class="col-12">
                    <h2 class="card-title">{{ title }}</h2>
                </div>
            </div>
        </div> -->
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImageCard',
    props: {
        title: {
            type: String,
            required: true,
            default: () => ""
        },
        link: {
            type: String,
            required: true,
            default: () => ""
        },
        image: {
            type: String,
            required: true,
            default: () => ""
        }
    },
    methods: {
        goTo: function(link) {
            this.$router.push(link);
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
    
    .card {
        border: none;
        border-radius: $border-radius;
        margin: 10px;
        z-index: 499;
        cursor: pointer;
    }

    .imageContainer {
        height: 150px !important;
        width: auto;
    }

    .card-img {
        border-top-right-radius: $border-radius;
        border-top-left-radius: $border-radius;
        width: 100%;
        height: 100%;
        object-fit: cover;

    }

    .card-body {
        background-color: white;
        border-bottom-left-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
    }

    .card-title {
        color: $primary-color;        
        margin: 0;
    }


    .card:hover .card-img-overlay {
        display: block;
        // animation: 750ms 1 forwards ani;
    }



</style>